import angular from 'angular';
import _ from 'lodash';

angular.module('webTools').factory('MenuBuilder', ['$rootScope', 'Auth', 'GridTools', '$ngRedux',
    function ($rootScope, Auth, GridTools, $ngRedux) {
        return {

            getFileContextMenu: function(selectedItems, gridData, view) {

                const store = $ngRedux.getState();

                view = view || 'documents';

                var menuCollection = [];

                menuCollection[0] = [{ id: 'download', action: 'launchLegacyDialog', data: 'download', icon: 'file-download', text: 'Download' }];
                
                if (!Auth.isWebView()) {
                    menuCollection[1] = [{ id: 'message', action: 'launchLegacyDialog', data: 'message', icon: 'envelope', text: 'Send Notification' }];
                }

                if (store.app.bravaVersion === '16.3') {
                    menuCollection[0].unshift({ id: 'bravahtml', action: 'launchLegacyDialog', data: 'bravahtml', icon: 'eye', text: 'View In Brava!' });
                }

                if (selectedItems.length === 1) {

                    menuCollection[0].unshift({ id: 'preview', action: 'launchLegacyDialog', data: 'preview', icon: 'eye', text: 'Preview' });

                    if (Auth.isWebView()) { return menuCollection };

                    menuCollection.push([
                        { id: 'versionhistory', action: 'launchLegacyDialog', data: 'versionhistory', icon: 'history', text: 'History' },
                        { id: 'documentlog', action: 'launchLegacyDialog', data: 'documentlog', icon: 'file-alt', text: 'Document Log' },
                        { id: 'notes', action: 'launchLegacyDialog', data: 'notes', icon: 'sticky-note', text: 'Document Notes' },
                        { id: 'updateprofile', action: 'launchLegacyDialog', data: 'updateprofile', icon: 'pen-square', text: 'Update Profile' }
                    ])

                    if (selectedItems.length === 1 && (selectedItems[0].StatusFlags & 64)) {
                        menuCollection[2].unshift({ id: 'relatedmessages', action: 'launchLegacyDialog', data: 'relatedmessages', icon: 'mail-bulk', text: 'Related Messages' });
                    }

                    if (_.includes(_.map(selectedItems, 'Activity'), 'In Process') && selectedItems.length === 1) {
                        menuCollection[1].push({ id: 'task', action: 'launchLegacyDialog', data: 'task', icon: 'scroll', text: 'Workflow Task' });
                    }

                    menuCollection.push([{ id: 'rename', action: 'openRenameDialog', data: 'rename', icon: 'pen', text: 'Rename File' },
                                         { id: 'getFileLink', action: 'openLinkDialog', data: 'getFileLink', icon: 'link', text: 'Link' }]);

                }

                if (!Auth.isWebView()) {
                    if (_.includes(_.map(selectedItems, 'Status'), 'Normal')) {
                        menuCollection[0].push({ id: 'checkout', action: 'launchLegacyDialog', data: 'checkout', icon: 'check', text: 'Check Out' });

                        if (view.toLowerCase() === 'projects' && selectedItems.length === 1) {
                            menuCollection[0].push({ id: 'checkoutSync', action: 'launchLegacyDialog', data: 'checkout-sync', icon: 'check', text: 'Check Out Sync' });
                        }

                    }

                  if (_.includes(_.map(selectedItems, 'Status'), 'Checked Out') && _.includes(_.map(selectedItems, 'CheckedOutBy'), Auth.getUsername())) {
                    if (view.toLowerCase() === 'projects' ) {
                      menuCollection[0].push({ id: 'project-checkin', action: 'launchLegacyDialog', data: 'project-checkin', icon: 'file-upload', text: 'Check In' });
                      menuCollection[0].push({ id: 'project-undocheckout', action: 'launchLegacyDialog', data: 'project-undocheckout', icon: 'undo', text: 'Undo Check Out' });
                    }
                    else {
                      menuCollection[0].push({ id: 'checkin', action: 'launchLegacyDialog', data: 'checkin', icon: 'file-upload', text: 'Check In' });
                      menuCollection[0].push({ id: 'undocheckout', action: 'launchLegacyDialog', data: 'undocheckout', icon: 'undo', text: 'Undo Check Out' });
                    }

                  }

                    menuCollection[1].push({ id: 'workflow', action: 'launchLegacyDialog', data: 'workflow', icon: 'cogs', text: 'Start Workflow' });
                    menuCollection[1].push({ id: 'quickapprovalworkflow', action: 'launchLegacyDialog', data: 'quickapprovalworkflow', icon: 'cogs', text: 'Quick Approval Workflow' });

                    if (view.toLowerCase() === 'documents') {
                        menuCollection.push([{ id: 'delete', action: 'launchLegacyDialog', data: 'delete', icon: 'trash', text: 'Delete' }]);
                    } else if (view.toLowerCase() === 'projects') {
                        menuCollection.push([{ id: 'projectRemovefile', action: 'openConfirmation', data: 'project-removefile', icon: 'trash', text: 'Remove From Project' }]);
                    }
                }

                return menuCollection;
            },
          getVersionedSearchMenu: function (selectedItems, gridData) {

            const store = $ngRedux.getState();

            var menuCollection = [];

            menuCollection[0] = [{ id: 'download', action: 'launchLegacyDialog', data: 'download', icon: 'file-download', text: 'Download' }];

            if (store.app.bravaVersion === '16.3') {
              menuCollection[0].unshift({ id: 'bravahtml', action: 'launchLegacyDialog', data: 'bravahtml', icon: 'eye', text: 'View In Brava!' });
            }

            menuCollection[0].unshift({ id: 'preview', action: 'launchLegacyDialog', data: 'preview', icon: 'eye', text: 'Preview' });

            if (Auth.isWebView()) { return menuCollection };

            if (!Auth.isWebView()) {
              if (_.includes(_.map(selectedItems, 'Status'), 'Normal')) {
                menuCollection[0].push({ id: 'checkout', action: 'launchLegacyDialog', data: 'checkout', icon: 'check', text: 'Check Out' });
              }

              if (_.includes(_.map(selectedItems, 'Status'), 'Checked Out') && _.includes(_.map(selectedItems, 'CheckedOutBy'), Auth.getUsername())) {
                menuCollection[0].push({ id: 'checkin', action: 'launchLegacyDialog', data: 'checkin', icon: 'file-upload', text: 'Check In' });

                menuCollection[0].push({ id: 'undocheckout', action: 'launchLegacyDialog', data: 'undocheckout', icon: 'undo', text: 'Undo Check Out' });
              }
            }

            menuCollection[1] = [{ id: 'updateprofile', action: 'launchLegacyDialog', data: 'updateprofile', icon: 'pen-square', text: 'Update Profile' }]

            return menuCollection;
          },
            getProjectFileContextMenu: function (selectedItems, gridData) {

              const store = $ngRedux.getState();

              var menuCollection = [];

              menuCollection[0] = [{ id: 'download', action: 'launchProjectFileDialog', data: 'download', icon: 'file-download', text: 'Download' }];

              if (store.app.bravaVersion === '16.3') {
                menuCollection[0].unshift({ id: 'bravahtml', action: 'launchProjectFileDialog', data: 'bravahtml', icon: 'eye', text: 'View In Brava!' });
              }

              if (selectedItems.length === 1) {

                menuCollection[0].unshift({ id: 'preview', action: 'launchProjectFileDialog', data: 'preview', icon: 'eye', text: 'Preview' });

                if (Auth.isWebView()) { return menuCollection };

                menuCollection.push([
                  { id: 'versionhistory', action: 'launchProjectFileDialog', data: 'versionhistory', icon: 'history', text: 'History' },
                  { id: 'updateprofile', action: 'launchProjectFileDialog', data: 'updateprofile', icon: 'pen-square', text: 'Update Profile' }
                ])

                if (selectedItems.length === 1 && (selectedItems[0].StatusFlags & 64)) {
                  menuCollection[0].unshift({ id: 'relatedmessages', action: 'launchProjectFileDialog', data: 'relatedmessages', icon: 'mail-bulk', text: 'Related Messages' });
                }

              }

              if (!Auth.isWebView()) {
                if (_.includes(_.map(selectedItems, 'Status'), 'Normal')) {
                  menuCollection[0].push({ id: 'project-checkout', action: 'launchProjectFileDialog', data: 'project-checkout', icon: 'check', text: 'Check Out' });
                }

                if (_.includes(_.map(selectedItems, 'Status'), 'Checked Out') && _.includes(_.map(selectedItems, 'CheckedOutBy'), Auth.getUsername())) {
                  menuCollection[0].push({ id: 'project-checkin', action: 'launchProjectFileDialog', data: 'project-checkin', icon: 'file-upload', text: 'Check In' });

                  menuCollection[0].push({ id: 'project-undocheckout', action: 'launchProjectFileDialog', data: 'project-undocheckout', icon: 'undo', text: 'Undo Check Out' });
                }

                menuCollection.push([{ id: 'projectRemovefile', action: 'launchProjectFileDialog', data: 'project-removefile', icon: 'trash', text: 'Remove From Project' }]);
              }

              return menuCollection;
            },
            getProjectContextMenu: function(selectedItems) {

              var menuCollection = [];

              menuCollection[0] = [{ id: 'project-getlatest', action: 'launchProjectDialog', data: { action: 'project-getlatest', payload: selectedItems[0].ID }, icon: 'download', text: 'Download' }];

              menuCollection[1] = [{ id: 'project-checkout', action: 'launchProjectDialog', data: { action: 'project-checkout', payload: selectedItems[0].ID }, icon: 'check', text: 'Check Out' }];
              menuCollection[1].push({ id: 'project-checkin', action: 'launchProjectDialog', data: { action: 'project-checkin', payload: selectedItems[0].ID }, icon: 'file-upload', text: 'Check In' });
              menuCollection[1].push({ id: 'project-undocheckout', action: 'launchProjectDialog', data: { action: 'project-undocheckout', payload: selectedItems[0].ID }, icon: 'undo', text: 'Undo Check Out' });

              menuCollection[2] = [{ id: 'project-addfile', action: 'launchProjectDialog', data: { action: 'project-addfile', payload: selectedItems[0].ID }, icon: 'file-plus', text: 'Add File' }];
              menuCollection[2].push({ id: 'project-edi', action: 'launchProjectEditor', data: { action: 'project-edit', payload: selectedItems[0].ID }, icon: 'edit', text: 'Edit Project' });
              menuCollection[2].push({ id: 'project-newversion', action: 'openConfirmation', data: 'project-newversion', icon: 'layer-plus', text: 'New Version' });
              menuCollection[2].push({ id: 'project-rename', action: 'launchProjectDialog', data: { action: 'project-rename', payload: selectedItems[0] }, icon: 'pen', text: 'Rename Project' });

              menuCollection[3] = [{ id: 'project-delete', action: 'openConfirmation', data: 'project-delete', icon: 'trash', text: 'Delete' }];


                return menuCollection;
            },

            getRecycleContextMenu: function() {
                
                var menuCollection = [];

                menuCollection[0] = [{ id: 'restore', action: 'launchLegacyDialog', data: 'restore', icon: 'trash-restore', text: 'Restore' }];
                menuCollection[0].push({ id: 'permanentdelete', action: 'launchLegacyDialog', data: 'permanentdelete', icon: 'trash-alt', text: 'Permanently Delete' });

                return menuCollection;
            },

            getMessageContextMenu: function(selectedItems) {

                var menuCollection = [];

                if(selectedItems.length === 0) { return []; }

                selectedItems = _.compact(selectedItems);

                menuCollection[0] = [];
                menuCollection[1] = [];

                if (_.includes(_.map(selectedItems, 'MessageRead'), '0')) {
                    menuCollection[1].push({ id: 'markRead', action: 'markRead', data: 'markRead', icon: 'envelope-open', text: 'Mark As Read' });
                }

                if (_.includes(_.map(selectedItems, 'MessageRead'), '1')) {
                    menuCollection[1].push({ id: 'markUnread', action: 'markUnread', data: 'markUnread', icon: 'envelope', text: 'Mark As Unread' });
                }

                menuCollection[2] = [{ id: 'launchMessageDelete', action: 'launchMessageDelete', data: 'launchMessageDelete', icon: 'trash', text: 'Delete' }];

                if (selectedItems.length === 1 && !Auth.isWebView()) {
                    menuCollection[0].push({ id: 'launchMessageReply', action: 'launchMessageReply', data: 'launchMessageReply', icon: 'reply', text: 'Reply' });
                    menuCollection[0].push({ id: 'launchMessageForward', action: 'launchMessageForward', data: 'launchMessageForward', icon: 'share', text: 'Forward' });
                } else { menuCollection = _.remove(menuCollection, 0); }
              
                return menuCollection;
            },

            getFolderMenu: function() {

                var menuCollection = [];

              if (!Auth.isWebView()) {

                menuCollection[0] = [{ id: 'newfile', action: 'launchFolderDialog', data: 'newfile', icon: 'file-plus', text: 'New Document' }];
                menuCollection[0].push({ id: 'import', action: 'launchFolderDialog', data: 'import', icon: 'file-import', text: 'Import' });

                menuCollection[0].push({ id: 'newfolder', action: 'launchFolderDialog', data: 'newfolder', icon: 'folder-plus', text: 'New Folder' });
                menuCollection[0].push({ id: 'newstructure', action: 'launchFolderDialog', data: 'newstructure', icon: 'folders', text: 'New Folder Structure' });

                if ($rootScope.workingFolder !== 'Documents') {
                  menuCollection.push([{ id: 'renameFolder', action: 'launchFolderDialog', data: 'renameFolder', icon: 'pen', text: 'Rename Folder' },
                  { id: 'getFolderLink', action: 'launchFolderDialog', data: 'getFolderLink', icon: 'link', text: 'Generate Link' }]);
                }

                return menuCollection;
              }
            },

            getProjectMenu: function(selectedItems) {

                var menuCollection = [];

                menuCollection[0] = [{ id: 'project-folder-edit', action: 'launchProjectEditor', data: 'project-folder-edit', icon: 'edit', text: 'Edit Project' }];
                menuCollection[0].push({ id: 'project-addfile', action: 'launchProjectDialog', data: { action: 'project-addfile', payload: selectedItems[0].ID }, icon: 'file-plus', text: 'Add File' });
                menuCollection[0].push({ id: 'project-newversion', action: 'openConfirmation', data: 'project-newversion', icon: 'layer-plus', text: 'New Version' });
                menuCollection[0].push({ id: 'rename-folder', action: 'launchFolderDialog', data: 'rename-folder', icon: 'pen', text: 'Rename Project' });
                menuCollection[0].push({ id: 'project-delete', action: 'openConfirmation', data: 'project-delete', icon: 'trash', text: 'Delete' });

                return menuCollection;
            },

            getProjectFolderMenu: function() {

                var menuCollection = [];

                menuCollection[0] = [{ id: 'project-new', action: 'launchFolderDialog', data: 'project-new', icon: 'plus', text: 'New Project' }];
              menuCollection[0].push({ id: 'project-newfolder', action: 'launchFolderDialog', data: 'project-newfolder', icon: 'folder-plus', text: 'New Folder' });

              if ($rootScope.workingFolder !== 'Projects') {
                menuCollection[0].push({ id: 'rename-folder', action: 'launchFolderDialog', data: 'rename-folder', icon: 'pen', text: 'Rename Folder' });
              }
                return menuCollection;
            },

            getRecycleMenu: function() {

                var menuCollection = [];

                menuCollection[0] = [{ id: 'restoreBin', action: 'launchFolderDialog', data: 'restoreBin', icon: 'trash-restore', text: 'Restore Recycle Bin' }];
                menuCollection[0].push({ id: 'emptyBin', action: 'launchFolderDialog', data: 'emptyBin', icon: 'trash-alt', text: 'Empty Recycle Bin' });

                return menuCollection;
            }
        }
    }
]);